import React, { useState, useEffect } from "react";
import { fetchOne } from "../utils/fetchResources";
import { Link, useParams, Prompt } from "react-router-dom";
import {
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  useTheme,
  Card,
  CardContent,
  Hidden,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import SetFile from "../components/SetFile";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(2, 0, 1),
  },
}));

export default function ThemesEdit(props) {
  const muiTheme = useTheme();
  const { id } = useParams();
  const classes = useStyles();
  const [theme, setTheme] = useState({});
  const [site, setSite] = useState({})
  const [loading, setLoading] = useState(true);
  const [unsaved, setUnsaved] = useState(false);
	const [isRegion, setIsRegion] = useState();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    (async () => {
      await fetchOne("themes", id, setTheme);
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      await fetchOne("sites", theme.site, setSite);
      setIsRegion(theme.isRegion ?? false)
      setLoading(false);
    })();
  }, [theme, theme.site])

  useEffect(()=>{
    setTheme({...theme, isRegion});
  },[isRegion]);

  const onChange = (e) => {
    setTheme({ ...theme, [e.target.name]: e.target.value });
    setUnsaved(true);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/themes/${id}`, {
      method: "PUT",
      credentials: "include",
      body: JSON.stringify(theme),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUnsaved(false);
          enqueueSnackbar("Theme updated successfully!", {
            variant: "success",
          });
        } else {
          console.log(data);
          const errorArray = data.error.split(",");
          errorArray.forEach((error) => {
            enqueueSnackbar(`${error}`, { variant: "error" });
          });
        }
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Prompt
        when={unsaved}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      <Typography component="h1" variant="h4">
        Edit Theme:{" "}
        <Link
          to={`/${site.slug}/themes/${theme.slug}`}
          target="_blank"
          style={{ color: muiTheme.palette.primary.main }}
        >
          {theme.name}
        </Link>
      </Typography>
      <form className={classes.form} onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={9}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Site"
              size="small"
              value={site.name}
              disabled
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="name"
              label="Theme Name"
              name="name"
              size="small"
              value={theme.name}
              autoFocus
              required
              onChange={onChange}
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="name"
              label="Slug"
              name="slug"
              size="small"
              value={theme.slug}
              autoFocus
              required
              onChange={onChange}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={theme.isRegion}
                  onChange={()=>{setIsRegion(!isRegion)}}
                  name="isRegion"
                  color="primary"
                />
              }
              label="Is this theme a region?"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Card>
              <CardContent>
                <Hidden smDown>
                  <Button
                    type="submit"
                    onClick={onSubmit}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Save
                  </Button>
                </Hidden>
                <SetFile
                  fileTitle="Featured Image"
                  resource={theme}
                  setResource={setTheme}
                  imageOnly={true}
                  fileLabel="featuredImage"
                  fileLabelFileName="featuredImageFile"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
